import React from "react"
import styled from "styled-components"

const StyledInput = styled.input`
  font-weight: 500;
  font-size: 16px;
  line-height: 142.5%;
  display: flex;
  align-items: center;
  text-align: center;
  padding: 20px;
  border: dashed 1.5px black;
  border-radius: 8px;
  letter-spacing: 0.055em;
  color: black;
  width: 100%;
  margin: 10px 0px 30px 0px;
  cursor: pointer;

  &:focus {
    outline: none;
  }
`

const FileInput = ({ field, ...props }) => {
  return <StyledInput type="file" {...field} {...props} multiple />
}

export { FileInput }
